module.exports = __webpack_public_path__ + "static/media/signature-symbol.b2e05a01.svg";